import { apiConfig } from '../../infrastructure/config/api.config';
import { LocalStorageTokenStorage } from '../../infrastructure/storage/local-storage-token-storage';
import { FetchHttpClient } from '../../infrastructure/http/fetch-http-client';
import { HttpContactRepository } from '../../infrastructure/repositories/http-contact.repository';
import { SubmitPublicContactUseCase } from '../../application/use-cases/contact/submit-public-contact.use-case';
import {
  GetContactMessagesUseCase,
  GetContactMessageByIdUseCase,
  UpdateContactMessageStatusUseCase,
  AssignContactMessageUseCase,
  ArchiveContactMessageUseCase,
  DeleteContactMessageUseCase,
  RetryContactEmailUseCase,
} from '../../application/use-cases/contact/contact-messages.use-cases';
import {
  GetContactRecipientsUseCase,
  CreateContactRecipientUseCase,
  UpdateContactRecipientUseCase,
  ChangeContactRecipientStatusUseCase,
  DeleteContactRecipientUseCase,
  ReorderContactRecipientsUseCase,
} from '../../application/use-cases/contact/contact-recipients.use-cases';
import {
  GetContactSettingsUseCase,
  GetPublicContactSettingsUseCase,
  UpdateContactSettingsUseCase,
  SendTestEmailUseCase,
} from '../../application/use-cases/contact/contact-settings.use-cases';

export interface ContactUseCases {
  // Public
  submitPublicContactUseCase: SubmitPublicContactUseCase;
  getPublicContactSettingsUseCase: GetPublicContactSettingsUseCase;

  // Messages
  getContactMessagesUseCase: GetContactMessagesUseCase;
  getContactMessageByIdUseCase: GetContactMessageByIdUseCase;
  updateContactMessageStatusUseCase: UpdateContactMessageStatusUseCase;
  assignContactMessageUseCase: AssignContactMessageUseCase;
  archiveContactMessageUseCase: ArchiveContactMessageUseCase;
  deleteContactMessageUseCase: DeleteContactMessageUseCase;
  retryContactEmailUseCase: RetryContactEmailUseCase;

  // Recipients
  getContactRecipientsUseCase: GetContactRecipientsUseCase;
  createContactRecipientUseCase: CreateContactRecipientUseCase;
  updateContactRecipientUseCase: UpdateContactRecipientUseCase;
  changeContactRecipientStatusUseCase: ChangeContactRecipientStatusUseCase;
  deleteContactRecipientUseCase: DeleteContactRecipientUseCase;
  reorderContactRecipientsUseCase: ReorderContactRecipientsUseCase;

  // Settings
  getContactSettingsUseCase: GetContactSettingsUseCase;
  updateContactSettingsUseCase: UpdateContactSettingsUseCase;
  sendTestEmailUseCase: SendTestEmailUseCase;
}

export const makeContactUseCases = (): ContactUseCases => {
  const tokenStorage = new LocalStorageTokenStorage();
  const httpClient = new FetchHttpClient(apiConfig.baseUrl, () => tokenStorage.getToken());
  const repository = new HttpContactRepository(httpClient);

  return {
    submitPublicContactUseCase: new SubmitPublicContactUseCase(repository),
    getPublicContactSettingsUseCase: new GetPublicContactSettingsUseCase(repository),

    getContactMessagesUseCase: new GetContactMessagesUseCase(repository),
    getContactMessageByIdUseCase: new GetContactMessageByIdUseCase(repository),
    updateContactMessageStatusUseCase: new UpdateContactMessageStatusUseCase(repository),
    assignContactMessageUseCase: new AssignContactMessageUseCase(repository),
    archiveContactMessageUseCase: new ArchiveContactMessageUseCase(repository),
    deleteContactMessageUseCase: new DeleteContactMessageUseCase(repository),
    retryContactEmailUseCase: new RetryContactEmailUseCase(repository),

    getContactRecipientsUseCase: new GetContactRecipientsUseCase(repository),
    createContactRecipientUseCase: new CreateContactRecipientUseCase(repository),
    updateContactRecipientUseCase: new UpdateContactRecipientUseCase(repository),
    changeContactRecipientStatusUseCase: new ChangeContactRecipientStatusUseCase(repository),
    deleteContactRecipientUseCase: new DeleteContactRecipientUseCase(repository),
    reorderContactRecipientsUseCase: new ReorderContactRecipientsUseCase(repository),

    getContactSettingsUseCase: new GetContactSettingsUseCase(repository),
    updateContactSettingsUseCase: new UpdateContactSettingsUseCase(repository),
    sendTestEmailUseCase: new SendTestEmailUseCase(repository),
  };
};
